import { Analytics } from "../../widgets/analytics";
import { EntryWorks } from "../../widgets/entryWorks";
import { Olympiades } from "../../widgets/olympiades";
import { Teacher } from "../../widgets/teacher";
import {
  // setDocumentTitle,
  useSiteNameContext,
} from "../../context/siteNameContext";

export function MainPage() {
  const { siteNameList } = useSiteNameContext();
  // setDocumentTitle(siteNameList, "main");

  return (
    <>
      <div
        style={{
          backgroundColor: "#183345",
          padding: "50px 10% 20px 10%",
          textAlign: "center",
        }}
      >
        <h1 style={{ color: "white", textTransform: "uppercase" }}>
          Онлайн тренажер и репетиторы
          <br />
          для учеников 2-7 класса
        </h1>
        <h2 style={{ color: "white" }}>2026/27 учебный год</h2>
        <p style={{ color: "white" }}>
          Подготовка к поступлению в математические классы школ Москвы и
          Санкт-Петербурга
        </p>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          overflow: "hidden",
        }}
      >
        <img
          className="RocketImage"
          style={{ width: "100%", height: "270px" }}
          src={"/images/frame-cloud2.svg"}
          alt={""}
        />
      </div>

      <div className="Wrapper">
        <EntryWorks />
        <Olympiades />
        <Teacher />
        <Analytics />
      </div>
    </>
  );
}
